import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, TrendingUp, Home, Zap, DollarSign } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  return <section className="relative pt-8 pb-14 md:pt-12 md:pb-20 px-4 overflow-hidden" data-id="element-106">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-[500px] bg-brand-yellow/10 blur-[120px] rounded-full pointer-events-none" data-id="element-107" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-108">
        <div className="text-center mb-10" data-id="element-109">
          <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="inline-flex items-center gap-2 bg-brand-gray border border-brand-yellow/30 px-4 py-2 rounded-full mb-6" data-id="element-110">
            <span className="text-xl" data-id="element-111">🔥</span>
            <span className="text-brand-yellow font-bold text-sm md:text-base tracking-wide" data-id="element-112">
              +3.000 PERSONAS YA COMENZARON
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-[2.125rem] sm:text-[2.75rem] md:text-6xl lg:text-7xl text-white mb-5 leading-[1.05] md:leading-[0.98] tracking-tight text-glow break-words max-w-[19ch] sm:max-w-[24ch] mx-auto" data-id="element-113">
            APRENDÉ MICROCEMENTO Y CONSEGUÍ TUS{' '}
            <span className="text-brand-yellow" data-id="element-114">PRIMEROS CLIENTES.</span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="text-lg md:text-2xl text-gray-300 max-w-3xl mx-auto mb-8 font-medium" data-id="element-115">
            El sistema paso a paso para aprender la técnica, calcular
            presupuestos y comenzar a ofrecer trabajos de microcemento incluso
            si hoy empezás desde cero.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3
        }} className="flex flex-wrap justify-center gap-x-4 gap-y-3 md:gap-8 mb-10 md:mb-12" data-id="element-116">
            {['Sin experiencia previa', 'Sin abrir un local', 'Sin maquinaria costosa', 'A tu ritmo'].map((bullet, i) => <div key={i} className="flex items-center gap-2 text-gray-200 font-semibold" data-id="element-117">
                <CheckCircle2 className="text-brand-yellow w-5 h-5" data-id="element-118" />
                <span data-id="element-119">{bullet}</span>
              </div>)}
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4
      }} className="relative max-w-4xl mx-auto mb-10 md:mb-16" data-id="element-120">
          <img src="https://cdn.magicpatterns.com/uploads/rnC4SmbU4HFAq3PV1KVyJf/ChatGPT_Image_21_may_2026_06_31_23.webp" alt="Sistema Microcemento Rentable" width={1536} height={1024} loading="eager"
        // @ts-expect-error fetchpriority is a valid HTML attribute
        fetchpriority="high" decoding="async" className="w-full h-auto rounded-2xl box-glow border border-brand-yellow/20" data-id="element-121" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5
      }} className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12" data-id="element-122">
          {[{
          icon: DollarSign,
          text: 'Ingresos reales'
        }, {
          icon: Home,
          text: 'Remodelaciones modernas'
        }, {
          icon: TrendingUp,
          text: 'Habilidad con demanda'
        }, {
          icon: Zap,
          text: 'Aplicable desde el primer día'
        }].map((benefit, i) => <div key={i} className="bg-brand-gray p-3 md:p-4 rounded-xl border border-white/5 flex items-center gap-3 text-left" data-id="element-123">
              <div className="bg-brand-yellow/10 p-2.5 rounded-full shrink-0" data-id="element-124">
                <benefit.icon className="text-brand-yellow w-5 h-5 md:w-6 md:h-6" data-id="element-125" />
              </div>
              <span className="font-bold text-sm md:text-base text-gray-200 leading-tight" data-id="element-126">
                {benefit.text}
              </span>
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} className="text-center" data-id="element-127">
          <Button className="mb-4" data-id="element-128">QUIERO ACCESO INMEDIATO</Button>
          <p className="text-gray-400 font-medium" data-id="element-129">
            Único pago de{' '}
            <span className="text-brand-yellow font-bold text-xl" data-id="element-130">
              $19.999 ARS
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}